import script from "./ProjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=31fd6a2d&lang=css"

const __exports__ = script;

export default __exports__